<div
  class="tags-input flex flex-wrap gap-1 position-relative align-items-center"
  tabindex="-1"
>
  <ng-template ngFor let-tag [ngForOf]="selectedTag" let-tagIndex="index">
    <span
      tabindex="-1"
      *ngIf="tag"
      class="tags-input-tag flex gap-1.5 items-center rounded-pill text-sm font-bold d-inline-flex"
      [class]="tagClass"
      [class.active]="toRemoved === tagIndex"
      >{{ key ? tag[key] : tag }}
      <a
        href="javascript:void(0)"
        class="text-cool-gray-60"
        (click)="removeTag(tagIndex)"
        tabindex="-1"
      >
        <cj-icon icon="times" pack="font-awesome-solid"></cj-icon>
      </a>
    </span>
  </ng-template>
  <div class="tags-input-text-wrapper" tabindex="-1">
    <input
      #input
      autocomplete="off"
      list=""
      role="combobox"
      name="datalist"
      (keydown)="onKeydown($event)"
      (click)="datalist.style.display = 'block'"
      (input)="onInput($event.target.value)"
      (focus)="onInput('')"
      (blur)="hide()"
    />
    <datalist id="datalist" role="listbox" #datalist>
      <ng-template ngFor let-option [ngForOf]="options" let-i="index">
        <option
          *ngIf="option"
          (mousedown)="onSelect(i); $event.preventDefault()"
          [value]="key ? option[key] : option"
          [attr.data-index]="i"
        >
          {{ key ? option[key] : option }}
        </option>
      </ng-template>
    </datalist>
  </div>
  <a
    class="expansion-indicator"
    href="javascript:void(0)"
    (click)="input.focus()"
  >
    <i class="fas fa-chevron-down"></i>
  </a>
</div>
